import {inject, provide, ref } from "vue";

const EXTENSION_CARD_PROVIDE_TOKEN = Symbol('EXTENSION_CARD_PROVIDE_TOKEN')
export function useExtensionCardProvide (ext) {
    provide(EXTENSION_CARD_PROVIDE_TOKEN, ext)
}

export function useExtensionCardInject () {
    const injectData = inject(EXTENSION_CARD_PROVIDE_TOKEN)

    if (!injectData) {
        throw new Error('Extension data must be provided')
    }

    return injectData
}
